// extracted by mini-css-extract-plugin
module.exports = {"container":"waitTime_container__eCNOZ","content":"waitTime_content__307je","bold":"waitTime_bold__1cq5S","button":"waitTime_button__1-bPT button_button__2n_ir"};